<template>
  <div class="code-container">
    <div
      v-show="!isFina"
      class="coupon">
      <div
        v-if="hasCoupon"
        class="coupon-body">
        <div
          class="flex flex-sb align">
          <div  class="coupon-content">
            <span class="title">Promo Code</span>
            <span class="coupon-title"> {{couponData.title}}</span>
          </div>
          <div >
            <div class="flex">
              <v-button
                plain
                class="flex-3"
                :disabled="!isUse||disabled"
                @click="handlerSelectCoupon">
                <font-awesome-icon
                  icon="exchange-alt"></font-awesome-icon>
              </v-button>
              <v-button
                plain
                class="flex-1"
                :disabled="!isUse||disabled"
                @click="handlerDelete(1)">
                <font-awesome-icon
                  icon="trash-alt"></font-awesome-icon>
              </v-button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="code-select-button">
        <div
          class="flex-sb flex aglin-inline">
          <div>
            <span class="title">Promo Code</span>
          </div>
          <div>
            <v-button
              plain
              :disabled="!isUse||disabled || couponDisabled"
              @click="handlerCoupon">Select</v-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="referrer">
      <div
        v-if="hasCode"
        class="coupon-body">
        <div

          class="flex flex-sb flex-align">

          <div  class="coupon-content ">

            <div class="flex flex-sb">
              <div class=" aglin-flex flex">
                <span class="title">Referrer</span>
              </div>
              <div v-if="!isRenew&&!isFina">
                <div class="flex">
                  <v-button
                    plain
                    class="flex-1"
                    :disabled="!isUse||disabled||isOutCoupon"
                    @click="handlerDelete(2)">
                    <font-awesome-icon
                      icon="trash-alt"></font-awesome-icon>
                  </v-button>

                </div>
              </div>
            </div>
            <div>
              <span class="code-title"> {{codeDate.code}}</span>
            </div>
            <div
              v-if="isUser"
              class="coupon-name">
              <span
                class="link"
                @click="handlerUser(customer_profile.id)">
                {{customer_name}}
              </span>
            </div>
            <div
              v-if="customer_profile.is_tier_base||customer_profile.verify_language||customer_profile.is_flagged"
              class="tags">
              <span
                v-if="customer_profile.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="customer_profile.verify_language"
                class="span-status"
                :class="{
                  'verified': customer_profile.verified == 20,
                  'pending_verify ': customer_profile.verified == -1,
                  'not_verify': customer_profile.verified == -2
                }">
                {{ customer_profile.verify_language }}
              </span>
              <span
                v-if="customer_profile.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!hasCode&&!isFina"
        class="code-select-button">
        <div
          class="form-item flex flex-sb">
          <div>
            <span class="title">Referral Code</span>
          </div>
          <div>
            <v-input
              v-model="code"
              :disabled="disabled||isOutCoupon"
              append="Apply"
              @handlerAppend="handlerAppend"/>
          </div>
        </div>
      </div>
    </div>
    <attach-customer
      ref="attachCustomer"
      @handlerSelectCustomer="handlerSelectCoupon"></attach-customer>
    <template v-if="!isFina">
      <coupon-dialog
        ref="coupon-dialog"
        :customerId="customerId||couponCustomerId"
        :orderId="orderId"
        :isQuote="isQuote"
        :isFina="isFina"
        :classId="classId"
        :customer="customer"
        :couponCode="couponCode"
        :formDataLock="formDataLock"
        :couponForm="couponForm"
        @isCanUse="handleCanUse"
        @coupon="computedCoupon">
      </coupon-dialog>
      <coupon-tip
        ref="coupon-tip"
        @removeCoupon="removeCoupon"></coupon-tip>
    </template>
  </div>
</template>
<script>
import {applyOrderCode, verifyPromoCode} from '@/api/order'
import {referApplyCode} from '@/api/refer'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import CouponDialog from '@/views/components/refer-coupon-select-dialog'
import CouponTip from '@/views/components/refer-coupon-tip'
import {getAccountDetail} from '@/api/account'

export default {
  name: 'codeSelect',
  components:{
    attachCustomer,
    CouponDialog,
    CouponTip
  },
  props: {
    orderId: [String, Number],
    customerId: [String, Number],
    classId: [String, Number],
    isQuote: {
      type: Boolean,
      default: true
    },
    isFina: {
      type: Boolean,
      default: false
    },
    customer:{
      type: Object,
      default: ()=>({})
    },
    form:{
      type: Object,
      default: ()=>({})
    },
    useCode:{
      type: Number,
      default: 1
    },
    isUser: {
      type: Boolean,
      default: false
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isOutCoupon: {
      type: Boolean,
      default: false
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    couponDisabled:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      code: '',
      isReferral:false,
      coupon:{},
      selectData:{},
      couponCustomerId:null,
      // hasCode:false
      customer_profile: {}
    }
  },
  computed:{
    customer_name(){
      let {isrd_nm} = this.customer_profile||{}
      return isrd_nm
    },
    couponForm(){
      let {company_id,product_id,basic_prm} = this.form||{}
      return {
        company_id:company_id||0,product_id,basic_prm:basic_prm||0
      }
    },
    hasCoupon(){
      //1 coupon 2 referral
      let {coupon={}} =  this.selectData||{}
      return coupon.coupon_code
    },
    hasCode(){
      //1 coupon 2 referral
      let {code={}} =  this.selectData||{}
      return code.code
    },
    couponData(){
      let {coupon} =  this.selectData||{}
      return coupon||{}
    },
    couponCode(){
      let {coupon_code=''} = this.couponData||{}
      return coupon_code
    },
    couponTitle(){
      if(this.couponData)
        return this.couponData.title
      else return ''
    },
    codeDate(){
      let {code} =  this.selectData||{}
      return code||{}
    },
    customer_id(){
      return this.customerId
    },
    isUse(){
      return this.useCode==1
    }
  },
  watch: {
    form:{
      // deep:true,
      immediate:true,
      handler(val){
        let {coupon_code,code,referrer, referrer_user_id,campaign_code,referrer_id} = val||{}
        let setParams = {}
        if(coupon_code){
          setParams.coupon = {title:coupon_code,coupon_code}
        }
        if(code||this.isFina&&referrer.code){
          setParams.code = {code:this.isFina?referrer.code:code, referrer,referrer_user_id}
        }
        if(campaign_code)
        {
          setParams.coupon= {title:campaign_code,coupon_code:campaign_code}
          setParams.is_campaign_code = 1
        }
        this.selectData = setParams
      }
    },
    'selectData.code.referrer_user_id':{
      immediate: true,
      handler(val){
        if(val){
          this.network().getAccountDetail()
        }
      }
    }
  },
  methods: {
    handlerUser(id){
      if(this.disabled)
        return
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    handlerCoupon() {
      if(this.isOutCoupon){
        return this.$emit('open')
      }
      if (!this.customerId) {
        this.$refs.attachCustomer.showAttachCustomer()
      } else {
        this.$refs['coupon-dialog'].changeDialog()
      }
    },
    handleCanUse(isCan) {
      this.$refs['coupon-tip'].changeDialog(isCan)
    },
    handlerSelectCoupon(cusId) {
      this.couponCustomerId = cusId
      this.$refs['coupon-dialog'].changeDialog()
    },
    handlerDelete(num) {
      let params = JSON.parse(JSON.stringify(this.selectData||{}))
      if(num==1)
      {
        params.coupon = {}
      }
      if(num==2)
      {
        params.code = {}
        this.code = ''
      }
      // this.selectData = params
      this.selectData = params
      this.handleCouponData()
    },
    //现在都是只可以更改一个。。那是不是直接清掉就可以？
    removeCoupon(){
      let params = this.selectData||{}
      params.coupon = {}
      params.code = params.code
      this.selectData = params
      // this.selectData = {}
      this.handleCouponData()
    },
    handleCouponData(){
      this.$emit('check-code',this.selectData)
    },
    handleComputedData(){
      this.$emit('computedCoupon',this.selectData)
    },
    computedCoupon(data,isCampaignCode=false) {
      let { coupon_code} = data||{}
      let params = JSON.parse(JSON.stringify(this.selectData||{}))
      this.selectData = {}
      params.is_campaign_code = isCampaignCode?1:0
      if (coupon_code) {
        this.coupon = data
        params.coupon_code = coupon_code
        params.coupon = { ...data}
      }else{
        params.coupon = null
        params.coupon_code = null
        this.couponData = null
      }
      // console.log('params--',params)
      this.selectData = params
      this.handleCouponData()
    },
    handlerAppend() {
      if(this.disabled)
        return
      // this.selectData.coupon = ''
      this.network().verifyPromoCode()
    },
    handlerReferral() {
      this.isReferral = true
    },
    network() {
      return {
        verifyPromoCode: async () => {
          let params = this.selectData||{}
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customerId,
              code: this.code
            })
            this.selectData = {}
            const {referrer_user_id,is_campaign_code} = data
            if (referrer_user_id) {
              params.code = {
                code: this.code,
                referrer_user_id
              }
              this.selectData = params
              this.handleCouponData()
              this.network().getAccountDetail()
            }
            // if(is_campaign_code==1){
            //   params.code = {
            //     code: this.code,
            //   }
            //   params.is_campaign_code=is_campaign_code
            //   this.selectData = params
            //   this.handleCouponData()
            // }
          } else {
            if (this.notApply) {
              params.code = {
                selectCode: 2,
                code: this.code,
                // referrer_user_id
              }
              this.selectData = params
            }
          }
        },
        // applyOrderCode: async () => {
        //   let {coupon={},code={}} = this.selectCode||{}
        //   let params = {}
        //   let {coupon_code}  = coupon||{}
        //   params.coupon = coupon_code
        //   params.code =code&&code.code
        //   const {data} = await applyOrderCode({
        //     order_id: this.orderId,
        //     customer_id: this.customerId,
        //     // code: this.code,
        //     // coupon:this.coupon.coupon_code||''
        //     ...params
        //   })
        //   this.$message({
        //     type: 'success',
        //     message: 'Success'
        //   })
        //   this.$emit('apply', {
        //     ...data,
        //   })
        //   this.hasCode = true
        //   //   this.formData.amount = data.amount
        //
        // },
        referApplyCode: async () => {
          const {data} = await referApplyCode({
            order_id: this.orderId,
            code: this.code
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          // this.$emit('apply', data.amount)
          this.$emit('apply', {
            ...data,
            code: this.code
          })
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.codeDate.referrer_user_id
          })
          this.customer_profile = data.customer_profile
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.code-container{
  .title{
    color: #24292E;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
  }
  .margin-bottom{
    margin-bottom: 20px;
  }
  .aglin-inline{
    border-bottom: 1px solid #E1E4E8;
  }
  .code-select-button {
    padding: 20px 0 0 0;
    ::v-deep .el-button {
      width: 100%;
      border-radius: 4px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 16px;
    }
    .margin-button{
      margin-bottom: 0!important;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .icon-left{
      color: #1d43a0;
      margin-right: 8px;
    }
    .hand{
      cursor:pointer
    }
  }
  .coupon-body{
    //margin-bottom: 20px;
    .flex{
      justify-items: center;
      align-items: center;
    }
    .flex-3{
      flex: 3;
      //margin-right: 8px;
    }
    .flex-1{
      flex: 1;
    }
    .align{
      align-items: center;
    }
    .flex-algin{
      align-items: center;
    }
    .coupon-content{
      //background: #fff;
      padding: 20px 0;
      //padding: 16px;
      //margin: 0 16px 16px 0;
      border-radius: 4px;
      width: 100%;

      //height: 120px;
      //border:1px solid #D1D5DA;
      display: flex;
      flex-direction: column;
      .aglin-flex{
        align-items: center;
        .margin-left{
          margin-left: 10px;
        }
      }
      .title{
        color: #24292E;
        //font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        margin-right: 10px;
      }
      .coupon-title{
        color: #586069;
        font-size:16px!important;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .code-title{
        color: #6A737D;
        font-weight: 400;
        font-size: 14px;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        height: 20px;
        line-height: 20px;
      }
      .coupon-name{
        span{
          color: #0366D6;
          font-family: Inter;
          font-size: 14px;
          margin-top: 8px;
          cursor:pointer;
        }
      }
      .tags{
        height: 20px;
        .span-status{
          display: inline-block;
          margin-right: 4px;
          padding: 0px 8px;
          height: 20px;
          border-radius: 100px;
          font-size: 12px;
          line-height: 20px;
          font-weight: 600;
          &.blue{
            color:#0366D6;
            border: 1px solid #0366D6;
          }
          &.verified{
            color:#22863a;
            border: 1px solid #22863a;
          }
          &.pending_verify{
            color:#dbab09;
            border: 1px solid #dbab09;
          }
          &.not_verify{
            color:#d73a49;
            border: 1px solid #d73a49;
          }
          &.flag{
            color:#C24E00;
            border: 1px solid #F66A0A;
          }
        }
      }
      .coupon-mark{
        margin-top: 8px;
        overflow: hidden;
        span{
          text-overflow: ellipsis;
          word-break: break-word;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      span{
        color: #586069;
        font-size: 12px;
      }
    }
  }
}
</style>
